import React, { Fragment, useContext, useState } from 'react';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/List";
import Collapse from "@material-ui/core/Collapse";
import { NavLink } from "react-router-dom";
import './style.css';
import { clearLocalData } from '../../utils/CoustomStorage';
import LoginModal from '../common/LoginModal';
import UserContext from '../ContextApi/UserContext';

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/home',
        // submenu: [
        //     {
        //         id: 11,
        //         title: 'Home style 1',
        //         link: '/home'
        //     },
        //     {
        //         id: 12,
        //         title: 'Home style 2',
        //         link: '/home2'
        //     },
        //     {
        //         id: 13,
        //         title: 'Home style 3',
        //         link: '/home3'
        //     },
        //     {
        //         id: 14,
        //         title: 'Home style 4',
        //         link: '/home4'
        //     },
        //     {
        //         id: 15,
        //         title: 'Home style 5',
        //         link: '/home5'
        //     },
        //     {
        //         id: 16,
        //         title: 'Home style 6',
        //         link: '/home6'
        //     },
        //     {
        //         id: 17,
        //         title: 'Home style 7',
        //         link: '/home7'
        //     },
        // ]
    },

    {
        id: 2,
        title: 'About',
        link: '/about',
    },

    {
        id: 6,
        title: 'Service',
        link: '/service',
        // submenu: [
        //     {
        //         id: 61,
        //         title: 'Service',
        //         link: '/service'
        //     },
        //     {
        //         id: 62,
        //         title: 'Service S2',
        //         link: '/service-s2'
        //     },
        //     {
        //         id: 63,
        //         title: 'Service S3',
        //         link: '/service-s3'
        //     },
        //     {
        //         id: 64,
        //         title: 'Service single',
        //         link: '/service-single/1'
        //     },
        // ]
    },
    {
        id: 7,
        title: 'Project',
        link: '/project',
        // submenu: [
        //     {
        //         id: 71,
        //         title: 'Project',
        //         link: '/project'
        //     },
        //     {
        //         id: 72,
        //         title: 'Project S2',
        //         link: '/project-s2'
        //     },
        //     {
        //         id: 73,
        //         title: 'Project S3',
        //         link: '/project-s3'
        //     },
        //     {
        //         id: 74,
        //         title: 'Project single',
        //         link: '/project-single/1'
        //     },
        // ]
    },


    {
        id: 88,
        title: 'Contact',
        link: '/contact',
    },
    {
        id: 88,
        title: 'Login',
        link: '/',
    }


]


const MobileMenu = () => {
    const { user } = useContext(UserContext)

    const [modal, setModal] = useState(false);
    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);
    const toggle = () => setModal(!modal);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const openLoginModal = () => {
        toggle()
        setMenuState(false)
    }
    const logout = () => {
        clearLocalData()
        window.location.reload();
    }
    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        console.log("Itms", item)
                        return (
                            <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                                {item.submenu ?
                                    <Fragment>
                                        <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                            <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                        </p>
                                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                            <List className="subMenu">
                                                <Fragment>
                                                    {item.submenu.map((submenu, i) => {
                                                        return (
                                                            <ListItem key={i}>
                                                                <NavLink onClick={ClickHandler} className="active"
                                                                    to={submenu.link}>{submenu.title}</NavLink>
                                                            </ListItem>
                                                        )
                                                    })}
                                                </Fragment>
                                            </List>
                                        </Collapse>
                                    </Fragment>
                                    :
                                    item.title == 'Login' ?
                                        <NavLink onClick={() => user && user?.role ? logout() : openLoginModal()} className="active">{user && user?.role ? "Logout" : "Login"}</NavLink>
                                        :
                                        <NavLink className="active" to={item.link}>{item.title}</NavLink>
                                }
                            </ListItem>
                        )
                    })}
                </ul>

            </div>

            <div className="showmenu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
            <LoginModal modal={modal} toggle={toggle} />
        </div>
    )
}

export default MobileMenu;